export const TOLGEE_KEYS = {
  whatIsSoaQuestion: {
    key: 'ZaiChat-questions-whatissoa',
    defaultValue: 'O que é o Share of Attention?',
  },
  whatIsSoaAnswer: {
    key: 'ZaiChat-mocked-answers-whatissoa',
    defaultValue:
      'O Share of Attention da Winnin Intelligence é uma métrica proprietária que estima a porcentagem de atenção dos consumidores direcionada às marcas em uma categoria específica, durante um período determinado. Essa métrica é calculada com base na interação dos usuários com vídeos relacionados a essas marcas nas redes sociais, levando em consideração a relevância de cada categoria em diferentes plataformas. Analisar o Share of Attention possibilita às marcas entenderem sua posição em relação à concorrência, permitindo ajustar suas estratégias de marketing e comunicação para aumentar sua relevância e impacto.',
  },
  isItGoodQuestion: {
    key: 'ZaiChat-questions-isitgood',
    defaultValue: 'Meu share está bom?',
  },
  isItGoodAnswer: {
    key: 'ZaiChat-mocked-answers-isitgood',
    defaultValue:
      'A soma do total da atenção do consumidor é sempre 100%. Se escolhemos comparar o Share of Attention entre 10 marcas, este valor de 100% estará dividido entre elas. Se a comparação envolver 30 marcas, seguiremos a mesma lógica. Portanto, a forma de interpretar seu Share of Attention é comparativa com quem está no topo e no final do ranking.',
  },
  whatInsightsQuestion: {
    key: 'ZaiChat-questions-whatinsights',
    defaultValue: 'Quais insights vejo aqui?',
  },
  whatInsightsAnswer: {
    key: 'ZaiChat-mocked-answers-whatinsights',
    defaultValue:
      'Vemos o Share of Attention diário: a parcela de atenção que sua marca domina somada com o share dos seus concorrentes. Lembrando que o total de atenção na categoria é sempre 100%. Se seus concorrentes não tiverem tido interações relevantes naquele dia, seu Share of Attention perante a categoria pode ter dado um salto. E vice-versa. Acompanhe diariamente o jogo da atenção na categoria aqui.',
  },
  whatInsightsDailyQuestion: {
    key: 'ZaiChat-questions-whatinsightsdaily',
    defaultValue: 'Quais insights vejo na evolução diária?',
  },
  whatInsightsDailyAnswer: {
    key: 'ZaiChat-mocked-answers-whatinsightsdaily',
    defaultValue:
      'Vemos o Share of Attention diário: a parcela de atenção que sua marca domina somada com o share dos seus concorrentes. Lembrando que o total da atenção na categoria é sempre 100%. Se seus concorrentes não tiverem tido interações relevantes naquele dia, seu Share of Attention perante a categoria pode ter dado um salto. E vice-versa. Acompanhe diariamente o jogo da atenção na categoria aqui.',
  },
  howToIncreasePositionQuestion: {
    key: 'ZaiChat-questions-howToIncreasePosition',
    defaultValue: 'Como aumento minha posição na categoria?',
  },
  whichPlatformToImproveQuestion: {
    key: 'ZaiChat-questions-whichPlatformToImprove',
    defaultValue: 'Em qual plataforma devo melhorar minha performance para aumentar meu Share of Attention?',
  },
  howToIncreasePositionOnRankingQuestion: {
    key: 'ZaiChat-questions-howToIncreasePositionOnRanking',
    defaultValue: 'Como aumento minha posição no ranking?',
  },
  whichContentIsStandingOutQuestion: {
    key: 'ZaiChat-questions-whichContentIsStandingOut',
    defaultValue: 'Quais foram os conteúdos de maior destaque desta semana?',
  },
}
